const test_tools = [
    {
        name: 'Jest',
        imgUrl: '/technologies/jest.svg'
    },
    {
        name: 'Cypress',
        imgUrl: '/technologies/cypress.svg'
    },
    {
        name: 'RSpec',
        imgUrl: '/technologies/rspec.svg'
    },
    {
        name: 'PHPUnit',
        imgUrl: '/technologies/php_unit.svg'
    }
]

export default test_tools